import { Route } from "react-router-dom";
import Signin from "../Auth/Signin";
import SignInCallback from "../Auth/SignInCallback";
import Logout from "../Auth/Logout";
import SilentRenew from "../Auth/SilentRenew";
import LogoutCallback from "../Auth/LogoutCallback";

export default (
    <>
        <Route caseSensitive={true} path="/signin" element={<Signin />} />
        <Route caseSensitive={true} path="/signin-oidc" element={<SignInCallback />} />
        <Route caseSensitive={true} path="/logout" element={<Logout />} />
        <Route caseSensitive={true} path="/silentrenew" Component={SilentRenew} />
        <Route caseSensitive={true} path="/logout/callback" element={<LogoutCallback />} />
    </>
);
